const supportTypo = {
  label: 'Support files',
  noResults: 'No results found'
};

export default supportTypo;
